export { default } from './DashboardLinkAccess';
export { default as reducer } from './DashboardLinkAccess.ducks';
export { default as sagas } from './DashboardLinkAccess.sagas';

import * as actions from './DashboardLinkAccess.ducks';
export { actions };
